import { useCallback } from "react";
import { NodeChange } from "reactflow";
import { CustomNode } from "../types";
import useStore from "../store/useStore";

const useNodeLogging = () => {
  const nodes = useStore((state) => state.nodes);

  const onNodesChange = useCallback(
    (changes: NodeChange[]) => {
      changes.forEach((change) => {
        if (change.type === "position" || change.type === "dimensions") {
          // Find node in current state before it gets updated
          const node = nodes.find((n) => n.id === change.id) as CustomNode;
          if (node) {
          } else {
          }
        }
      });
    },
    [nodes],
  );

  return { onNodesChange };
};

export default useNodeLogging;
